import { FirebaseApp, initializeApp } from "firebase/app";
import { FirebaseConfig } from "../../config/FirebaseConfig";
import { IFirebaseService } from "./IFirebaseService";
import { injectable } from "inversify";

@injectable()
export default class FirebaseService implements IFirebaseService {
    private app: FirebaseApp | null = null;

    public initialize(): void {
        this.app = initializeApp(FirebaseConfig);
    }

    get appInstance(): FirebaseApp {
        if (!this.app) {
            this.initialize();
        }

        return this.app!;
    }
}